module.exports = __webpack_public_path__ + "static/img/test11.500de20a.gif";